'use client'

import BlocksRenderer from 'components/blocks-renderer/BlocksRenderer'
import styles from './StyledBlocksRenderer.module.scss'
import { StyledBlocksRendererProps } from './types'
import classNames from 'classnames'
import { MediaModel } from 'types/cms/components'
import { Img, List } from '@boltenergy-be/design-system'
import { ReactElement } from 'react'

const StyledBlocksRenderer = ({ className, ...props }: StyledBlocksRendererProps) => {
  return (
    <div {...{ className }}>
      <BlocksRenderer
        {...props}
        blocks={{
          list: ({ children, format }) => (
            <List as={format === 'ordered' ? 'ol' : 'ul'} className="mt-100 mb-300 gap-200">
              {children as ReactElement[]}
            </List>
          ),
          quote: ({ children }) => <blockquote className={classNames(styles.quote, 'serif')}>{children}</blockquote>,
          image: ({ image }) => {
            return (
              <Img
                publicId={(image.provider_metadata as MediaModel['provider_metadata']).public_id}
                alt={image.alternativeText || ''}
                className={styles.image}
                fill
              />
            )
          }
        }}
      />
    </div>
  )
}

export default StyledBlocksRenderer
